import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import ServiceText from '../common/serviceText';
import image from '../../assets/images/services/services.jpg';

const Section = Styled.section.attrs((props) => ({ id: 'services' }))`
background: ${color.tertiaryAlt};
display: grid;
grid-template-columns: repeat(2, 1fr);
@media only screen and (max-width:700px){
grid-template-columns: repeat(1, 1fr);
grid-template-rows: 50rem 1fr;
}
}`;

const Image = Styled.figure`
position:relative;
img{width: 100%;height:100%; object-fit:cover};
`;

const FloatingText = Styled.p`
color:${color.white};
position: absolute;
bottom:50px;
left:40px;
`;

const Services = () => {
  return (
    <Section>
      <Image>
        <img src={image} alt="Pet and Owner Playing" />
        <FloatingText>Ollie and Maggie</FloatingText>
      </Image>
      <ServiceText />
    </Section>
  );
};

export default Services;
